import {Component, inject} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent, MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import {ReactiveFormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import { AsyncPipe } from '@angular/common';
import {TextFieldModule} from '@angular/cdk/text-field';
import {FileDragAndDropDirective} from '../../../../shared/directives/file-drag-and-drop.directive';
import {Community} from '../../classes/community';
import {MatCheckboxChange, MatCheckboxModule} from '@angular/material/checkbox';
import {Observable, take} from 'rxjs';
import {UploadedFile} from '../../../../core/classes/uploaded-file';
import {CommunityService} from '../../../../services/community.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import { SNACKBAR_DURATION } from '../../../../shared/constants/snackbar.constants';

interface ModalData {
  communities: Observable<Community[]>
}

@Component({
    selector: 'tgrid-file-upload',
    imports: [
    MatButtonModule,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    ReactiveFormsModule,
    TextFieldModule,
    FileDragAndDropDirective,
    MatCheckboxModule,
    AsyncPipe,
],
    templateUrl: './file-upload.component.html',
    styleUrl: './file-upload.component.scss',
})
export class FileUploadComponent {
  public communityService = inject(CommunityService);
  public data: ModalData = inject(MAT_DIALOG_DATA);
  public ref = inject(MatDialogRef<FileUploadComponent>);
  private snackbar = inject(MatSnackBar);

  public files: UploadedFile[] = [];
  public selectedCommunities = new Map<number, Community>();
  public showCommunities: boolean = false;

  constructor() {
    this.data?.communities
      .pipe(take(1))
      .subscribe(communities => {
        if(communities.length === 1) {
          const community = communities[0];
          this.selectedCommunities.set(community.id, community);
          return;
        }

        this.showCommunities = true;
      });
  }


  public addFile(files: FileList | null) {
    if (files == null) return;

    for (let i = 0; i < files.length; i++) {
      const current = files[i];
      const uploadedFile = new UploadedFile();
      uploadedFile.file = current;
      uploadedFile.fileName = current.name;
      uploadedFile.displayName = current.name;
      this.files.push(uploadedFile);
    }

  }

  public removeFile(uploadedFile: UploadedFile): void {
    const index = this.files.findIndex(file => file.fileName === uploadedFile.fileName);
    this.files.splice(index,1);
  }


  public uploadFiles(): void {
    this.communityService.uploadFiles(this.files, Array.from(this.selectedCommunities.values())).subscribe(
      {
        next: (res) => {
          this.ref.close(res);
        },
        error: (errorResponse: unknown) => {
          const plural = (this.files.length === 1)? 'file': 'files';
          const err = errorResponse as {error?: {userMessage?: string}};
          const message = err?.error?.userMessage || `Failed to upload ${plural}.`;
          this.snackbar.open(message, 'X', {duration: SNACKBAR_DURATION.LONG, panelClass: 'snackbar-failure'});
        },
      });
  }

  public updateSelection(event: MatCheckboxChange, community: Community) {
    if (event.checked) {
      this.selectedCommunities.set(community.id, community);
    } else {
      this.selectedCommunities.delete(community.id);
    }
  }
}
